import {Injectable} from '@angular/core'
import {Router} from '@angular/router'
import {Observable} from 'rxjs'
import {AuthService} from '@service/auth/auth.service'

@Injectable({
  providedIn: 'root',
})
export class LoginGuardService {
  constructor(
    private readonly authService: AuthService,
    private readonly router: Router
  ) {}

  canActivate(): boolean | Observable<boolean> | Promise<boolean> {
    return this.authService
      .authenticated()
      .then(response => {
        if (response) {
          this.router.navigate([''])
        }
        return true
      })
      .finally(() => true)
  }
}
